// UI 조각들끼리 주고받는 window 이벤트 이름(서로를 import하지 않게 한곳에 둔다).
/** 단축키 안내를 열어 달라는 요청(설정 창의 「단축키 안내」 단추 → ui/index.ts). 도움말 오버레이 자체는 helpOverlay.ts */
export const HELP_EVENT = 'dh-open-help';
/** 일일 의뢰 게시판을 열어 달라는 요청(퀘스트 창의 「일일 의뢰 열기」 → dailyPanel.ts) */
export const DAILY_OPEN_EVENT = 'dh-open-daily';
/** 오른쪽 위 메뉴 줄 「일일」: 일일 패널 열기·닫기(같은 단추를 다시 누르면 닫는다) */
export const DAILY_TOGGLE_EVENT = 'dh-toggle-daily';
/** 퀘스트 창을 열 때 처음 보일 탭을 정한다(detail = 'active' | 'done' | 'adventure' | 'trial'). 추적기의 현상금 칩 → questWindow.ts. 보내지 않으면 늘 「진행 중」 */
export const QUEST_TAB_EVENT = 'dh-quest-tab';
/** 결제 제안 띠 「보기」: 다음에 여는 잡화상 창을 젬 탭으로 열어 달라는 요청(iap/offers.ts → rpg.ts) */
export const OPEN_IAP_TAB_EVENT = 'dh-open-iap-tab';
